import Modifier from "../Modifier";

class RateOfChangeModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'roc';
    }

    compute(data) {
        let divider = null;

        return data.map(function (point) {
            let curDiv = divider;
            divider = point.value;

            if (curDiv === null) {
                point.value = null;
                return point;
            }

            if (curDiv === 0) {
                point.value = 0;
                return point;
            }

            point.value = ((point.value / curDiv) - 1) * 100;
            return point;
        })
    }

}

export default RateOfChangeModifier;
